import { html, TemplateResult, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SearchV3UIBase } from './search-v3-ui-base';
import { SearchV3Result } from '../search-v3.interface';

/**
 * Redirect Search UI Component
 * 
 * Extends the base SearchV3UIBase component to provide default navigation behavior:
 * - Suggestions are rendered as clickable links that navigate to search results
 * - Clicking a suggestion redirects user to the search results page
 * - This is the default behavior for Product and Articles tabs
 */
@customElement('mhecomm-search-v3-ui-redirect')
export class SearchV3UIRedirect extends SearchV3UIBase {
  
  /**
   * Renders suggestion items as clickable links (default navigation behavior)
   * Clicking a suggestion will navigate to the search results page
   */
  protected renderSuggestionItem(suggestion: SearchV3Result, highlighted: boolean, index: number, handleSelect: (item: any) => void): TemplateResult {
    return html`<a
      class="dropdown-item ${highlighted ? 'bg-light' : ''}"
      id="item-${index}"
      role="option"
      aria-selected=${highlighted}
      @click=${() => {
        handleSelect(suggestion);
        this.searchResultClickAnalytic?.(suggestion);
      }}
      href="${suggestion.redirectUrl}"
      tabindex="-1"
    >
      ${suggestion.term} ${suggestion.label ? html`<span class="text-primary">${suggestion.label}</span>` : nothing}
    </a>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-search-v3-ui-redirect': SearchV3UIRedirect;
  }
}
